import {
    INCREMENT_COUNTER,
    DECREMENT_COUNTER,
    QUESTION_INPUT
} from "./testConstants";

import { toastr } from "react-redux-toastr";

export const incrementCounter = () => {
    return {
        type: INCREMENT_COUNTER
    };
};

export const decrementCounter = () => {
    return {
        type: DECREMENT_COUNTER
    };
};

export const questionInput = question => {
    // return {
    //     type: QUESTION_INPUT,
    //     payload: {
    //         question
    //     }
    // };

    return async dispatch => {
        try {
            dispatch({
                type: QUESTION_INPUT,
                payload: {
                    question
                }
            });
            toastr.success("Success!", "Form submitted successfully");
        } catch (error) {
            toastr.error("Oops", "Something went wrong");
        }
    };
};

export const createNewDocument = () => {
    console.log("function called");
    return async (dispatch, getState, { getFirestore }) => {
        const firestore = getFirestore();
        const user = firestore.auth().currentUser;
        const photoURL = getState().firebase.profile.photoURL;
        console.log("User profile id ", user);
        try {
            let querySnap = await firestore
                .collection("Bangla")
                .orderBy("random")
                .get();
            let data = [];
            for (let i = 0; i < 30; i++) {
                data.push(querySnap.docs[i].data());
            }

            firestore
                .collection("BanglaTests")
                .doc("RandomTest1")
                .set({
                    title: "RandomTest1",
                    data: data,
                    attendees: {
                        [user.uid]: {
                            photoURL: photoURL || "/assets/user.png",
                            displayName: user.displayName
                        }
                    },
                    category: "Bangla"
                });
        } catch (error) {
            console.log("Error message :", error.message);
        }
    };
};
